<!--<ng-container *ngIf='isComeback == null && souscription'>
    <app-quote-comeback [souscription]='souscription' (valueEmitter)='changes($event)'></app-quote-comeback>
</ng-container>

<ng-container *ngIf='isComeback != null || !souscription'>
    <router-outlet></router-outlet>
</ng-container>-->
<router-outlet></router-outlet>